import { render, staticRenderFns } from "./qualification-5g.vue?vue&type=template&id=406fb0c2&scoped=true"
import script from "./qualification-5g.vue?vue&type=script&lang=js"
export * from "./qualification-5g.vue?vue&type=script&lang=js"
import style0 from "./qualification-5g.vue?vue&type=style&index=0&id=406fb0c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fb0c2",
  null
  
)

export default component.exports